import { useQuery } from 'react-query';
import { network } from 'services/network';
import { ProjectTreeNode } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';
import { QueryKeys } from 'api/queryKeys';

export const queryFn = (params: QueryParams) => {
    return network.post('api/bo/getVersionDetails', params).then((response) => response.data);
};

export const useQueryVersionList = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['versionsListByContract', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(Number.isInteger(params.contractId)) && Boolean(params.ids.length > 0),
        cacheTime: 0,
    });
};

interface QueryParams {
    contractId: number | undefined;
    ids: number[];
}

export interface QueryResponse {
    contractId: number;
    contractName: string;
    contractUuid: ProjectTreeNode['uuid'];
    maxLevel: number;
    projectId: number;
    projectName: string;
    projectUuid: ProjectTreeNode['uuid'];
    sourceFile: string;
    versionDate: number;
    versionDbId: number;
    versionHashCode: number;
    versionName: string;
    versionUniqueId: number;
}
